import CheckNewRequestModifyPage from "../../shared/checkNewRequest/CheckNewRequestModifyPage";
import { CHECK_NEW_REQUEST_CONFIG } from "../../shared/checkNewRequest/checkNewRequestConfig";

const SolarentOperatorCheckNewRequestModifyPage = () => (
  <CheckNewRequestModifyPage config={CHECK_NEW_REQUEST_CONFIG.solarentOperator} />
);

export default SolarentOperatorCheckNewRequestModifyPage;
